module.exports = {
  login: '帐号或密码错误',
  ok: '操作成功',
  error: '操作失败',
  time: '请先选择一个时间区间',
  empty: '暂无任何数据',
  
  register: {
    ok: '注册成功',
    error: '注册失败，可能帐号重复',
  },
  
  cex: {
    no: '线路暂不开放',
    price: '超出收件范围',
    level: '您暂未放开下单权限',
    
    tool: {
      count: '长宽高总和不得超过'
    }
  },
  
  user: {
    money: '您的余额已不足'
  }
}